import { render } from "./ModalResultQuiz.vue?vue&type=template&id=db4dd6c0"
import script from "./ModalResultQuiz.vue?vue&type=script&lang=js"
export * from "./ModalResultQuiz.vue?vue&type=script&lang=js"
script.render = render

export default script